import type { EliteAdvanceCostMode } from '../types';
import { useSettingsStore } from '../stores/settings';

/**
 * Calculate the effective XP cost for an elite advance based on the active cost mode.
 *
 * - 'double' (home rule, default): baseCost × 2
 * - 'flat-500' (RAW Ch02): baseCost + 500
 */
export function calculateEliteAdvanceCost(baseCost: number, mode?: EliteAdvanceCostMode): number {
  const effectiveMode = mode ?? useSettingsStore.getState().eliteAdvanceCostMode;
  return effectiveMode === 'flat-500' ? baseCost + 500 : baseCost * 2;
}

/**
 * Return a human-readable label for the elite advance surcharge.
 */
export function eliteAdvanceCostLabel(mode?: EliteAdvanceCostMode): string {
  const effectiveMode = mode ?? useSettingsStore.getState().eliteAdvanceCostMode;
  return effectiveMode === 'flat-500' ? 'Elite Advance (+500 XP)' : 'Elite Advance (2× cost)';
}
